import Grid from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useContext, useEffect, useState } from "react";
import { APIContext } from "../Contexts/APIContext";
import CircularProgress from "@mui/material/CircularProgress";
import TableContainer from "@mui/material/TableContainer";
import ResponsiveTable from "../Utilities/ResponsiveTable";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import SessionListViewModel from "./ViewModel/SessionListViewModel";
import { SessionContext } from "../Contexts/SessionContext";
import Button from "@mui/material/Button";

export default function SavedSessionContainer() {
    const { get, loading } = useContext(APIContext);
    const { loadSession } = useContext(SessionContext);
    const [scope, setScope] = useState('user');
    const [sessions, setSessions] = useState<SessionListViewModel[]>([]);

    const handleScopeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setScope(event.target.value);
    }

    const handleLoadSession = (id: string) => () => {
        loadSession(id);
    }

    const getData = async () => {
        await get("Session", `GetSessions?scope=${scope}`, setSessions);
    };

    const handleArchiveSession = (id: string) => async () => {
        await get("Session", `ArchiveSession?id=${id}`);
        await getData();
    };

    useEffect(() => {
        getData()
    }, [scope])



    return (
        <Grid container>
            <Grid size={9}>
                <Typography variant={"h4"} >Saved Sessions</Typography>
            </Grid>
            <Grid size={3}>
                <TextField
                    select
                    label="Session Scope"
                    value={scope}
                    onChange={handleScopeChange}
                >
                    <MenuItem value="user">My Sessions</MenuItem>
                    <MenuItem value="site">Team Sessions</MenuItem>
                    <MenuItem value="org">Organisation Sessions</MenuItem>
                </TextField>
            </Grid>
            <Grid size={12} component={Paper}>
                {loading ?
                    <CircularProgress />
                    :
                    <TableContainer>
                        <ResponsiveTable>
                            <TableHead>
                                <TableCell>Session Name</TableCell>
                                {scope !== 'user' && <TableCell>User</TableCell>}
                                <TableCell />
                            </TableHead>
                            <TableBody>
                                {sessions.map(session =>
                                    <TableRow>
                                        <TableCell>{session.name}</TableCell>
                                        {scope !== 'user' && <TableCell>{session.userName}</TableCell>}
                                        <TableCell>
                                            <Button fullWidth={false} onClick={handleLoadSession(session.id)}>Load</Button>
                                        </TableCell>
                                        <TableCell>
                                            <Button fullWidth={false} onClick={handleArchiveSession(session.id)}>Archive</Button>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </ResponsiveTable>
                    </TableContainer>
                }
            </Grid>
        </Grid>
    );
}